import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { LoginService } from './login.service';
//import { inject } from '@angular/core';


@Injectable({
  providedIn: 'root',
})

export class Apiv1Service {
  authenticate(header: string): Observable<string> {
    return this.http.get(PROTOCOL + '://' + SERVER + PREFIX_V1 + '/permission_check', {
      headers: new HttpHeaders({ Authorization: header }),
      responseType: 'text'
    });
  }

  async getUserId(): Promise<string> {

const headers = this.produceHeaders()
const getRes$ = this.http.get(PROTOCOL+"://"+SERVER+PREFIX_V1+'/permission_check', { headers, responseType: 'text' })
const result = await firstValueFrom(getRes$);


    return result;
  }


  constructor(private http: HttpClient) {}

   //auth = inject(LoginService);



produceHeaders():HttpHeaders {
  console.log("Apiv1Service::produceHeaders(): " + "Start");
  console.log("Apiv1Service::produceHeaders(): " + "Var [this.storageKey]: ["+this.storageKey+"].");

var headers :HttpHeaders = new HttpHeaders();
var header = this.getAuthHeader()
if (header)
{
  headers = new HttpHeaders({ Authorization: header });
}
else{
  
}
return headers;
}




async checkPermissionForPathAndActionOnCheck(c: Check) :Promise<boolean> {

  return this.checkPermissionForPathAndAction(c.path, c.action );
}


async checkPermissionForPathAndAction(path: string, action:string) :Promise<boolean> {
console.log("checkPermissionForPathAndAction() path: ["+path+"], action: ["+action+"]." )
var res = false;

const headers = this.produceHeaders()

var params = new HttpParams();
params = params.append("path", PREFIX_V1 + path);
params = params.append("action", action);

const getRes$ = this.http.get(PROTOCOL+"://"+SERVER+PREFIX_V1+'/permission_check', { headers, params, responseType: 'text' })
const result = await firstValueFrom(getRes$);

if (result.length>0){
  res = true;
}

return res;
}

getOneForPath(path: string ) :Observable<String> {
console.log("getOneForPath() path: ["+path+"]." )
var res = false;

const headers = this.produceHeaders()

var params = new HttpParams();

//var apiDir = PREFIX_V1 + path;
params = params.append("sorter", "");
params = params.append("filter", "");
params = params.append("paging", "");

const getRes$ = this.http.get(PROTOCOL+"://"+SERVER+PREFIX_V1+path, { headers, params, responseType: 'text' })
//const result = await firstValueFrom(getRes$);

return getRes$;
}

deleteForPath(path: string ) :Observable<String> {
console.log("deleteForPath() path: ["+path+"]." )
var res = false;

const headers = this.produceHeaders()

var params = new HttpParams();

//var apiDir = PREFIX_V1 + path;
params = params.append("sorter", "");
params = params.append("filter", "");
params = params.append("paging", "");

const getRes$ = this.http.delete(PROTOCOL+"://"+SERVER+PREFIX_V1+path, { headers, params, responseType: 'text' })
//const result = await firstValueFrom(getRes$);

return getRes$;
}


addForPath(path: string, content: any ) :Observable<Object> {
console.log("addForPath() path: ["+path+"]." )
var res = false;

const headers = this.produceHeaders()


const getRes$ = this.http.post(PROTOCOL+"://"+SERVER+PREFIX_V1+path, content,{ headers, responseType: 'json' })

return getRes$;
}


updateForPath(path: string, content: any ) :Observable<Object> {
console.log("updateForPath() path: ["+path+"]." )
var res = false;

const headers = this.produceHeaders()


const getRes$ = this.http.put(PROTOCOL+"://"+SERVER+PREFIX_V1+path, content,{ headers, responseType: 'json' })

return getRes$;
}

updateForPathString(path: string, content: any ) :Observable<String> {
console.log("updateForPath() path: ["+path+"]." )
var res = false;

const headers = this.produceHeaders()


const getRes$ = this.http.put(PROTOCOL+"://"+SERVER+PREFIX_V1+path, content,{ headers, responseType: 'text' })

return getRes$;
}

getAllForPath(path: string, params: HttpParams ) :Observable<any[]> {
  console.log("getAllForPath() path: ["+path+"]." )
  var res = false;

  const headers = this.produceHeaders()


  const getRes$ = this.http.get<any[]>(PROTOCOL+"://"+SERVER+PREFIX_V1+path+'/getall', { headers, params })

  return getRes$;
}

getCountForPath(path: string, params: HttpParams ) : Observable <number> {
console.log("getCountForPath() path: ["+path+"]." )
var res = false;

const headers = this.produceHeaders()

const getRes$ = this.http.get<number>(PROTOCOL+"://"+SERVER+PREFIX_V1+path+'/count', { headers, params })



return getRes$;
}

private storageKey = 'basic_auth_header';


logout() {
  console.log("Apiv1Service::this.logout(): " + "Start");
  console.log("Apiv1Service::this.logout(): " + "Var [this.storageKey]: ["+this.storageKey+"].");
sessionStorage.removeItem(this.storageKey);
localStorage.removeItem('basic_auth_header_persistent');
}

login(  header: string) {
  sessionStorage.setItem(this.storageKey, header);
}

getAuthHeader(): string | null {
  console.log("Apiv1Service::getAuthHeader(): " + "Start");
  console.log("Apiv1Service::getAuthHeader(): " + "Var [this.storageKey]: ["+this.storageKey+"].");



return sessionStorage.getItem(this.storageKey) ?? localStorage.getItem('basic_auth_header_persistent');
}

isLoggedIn(): boolean {
return !!this.getAuthHeader();
}

}

export interface Check {
  path: string;
  action: string;

};
const PROTOCOL:  string = window.location.protocol.slice(0, -1)
//const SERVER:    string = "localhost:8080"
const SERVER:    string = window.location.host
const PREFIX_V1: string = "/api/v1"